import { newSpecPage } from '@stencil/core/testing';
import { SallaMaintenanceAlert } from '../salla-maintenance-alert';

describe('salla-maintenance-alert', () => {
  it("should build", () => {
    expect(new SallaMaintenanceAlert()).toBeTruthy();
  })

  describe("Rendering", () => {
    let page;

    it("should be able to render component in dom", async () => {
      page = await newSpecPage({
        components: [SallaMaintenanceAlert],
        html: `<salla-maintenance-alert></salla-maintenance-alert>`
      })
      let productsList = await page.doc.querySelector("salla-maintenance-alert")
      expect(productsList.style.display).not.toBe('none')
      expect(productsList).not.toBeNull()
    })

    it("should be able to close alert after loading", async () => {
      salla.storage.get = (key) => {
        if(key == "hide_salla-maintenance-alert_at"){
          return Date.now()
        }
      }
      page = await newSpecPage({
        components: [SallaMaintenanceAlert],
        html: `<salla-maintenance-alert></salla-maintenance-alert>`
      })
      let productsList = await page.doc.querySelector("salla-maintenance-alert")
      expect(productsList.style.display).toBe('none')
    })
  })
});
